export default "__VITE_ASSET__CIZ0iII3__"